'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background-color: rgba(255,255,255,0.3);\n  padding: 0.5rem;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background-color: rgba(255,255,255,0.3);\n  padding: 0.5rem;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 14pt;\n'], ['\n  font-size: 14pt;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 16pt;\n  font-weight: bold;\n'], ['\n  font-size: 16pt;\n  font-weight: bold;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _giftCardListButton = require('./gift-card-list-button');

var _giftCardListButton2 = _interopRequireDefault(_giftCardListButton);

var _paypalButton = require('./paypal-button');

var _paypalButton2 = _interopRequireDefault(_paypalButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Col = _styledComponents2.default.div(_templateObject);

var Invite = _styledComponents2.default.p(_templateObject2);

var Price = _styledComponents2.default.span(_templateObject3);

/** @class GroupPurchase
  * A component that renders a fundraising purchase
  * button for the affiliate group associated with
  * the provided token
  * @prop {string} token - the token of the affiliate group
  * @prop {string} name - the name of the show
  * @prop {string} expoID - the ID of the expo
  * @prop {string} showID - the ID of the show
  */

var GroupPurchase = function (_Component) {
  _inherits(GroupPurchase, _Component);

  /** @constructor
    * Constructs the GroupPurchase instance
    */
  function GroupPurchase(props) {
    _classCallCheck(this, GroupPurchase);

    var _this = _possibleConstructorReturn(this, (GroupPurchase.__proto__ || Object.getPrototypeOf(GroupPurchase)).call(this, props));

    _this.state = {
      status: "loading"
    };
    return _this;
  }
  /** @method componentWillMount
    * Retrieves the affiliate group associated with
    * the provide token from the realtime database
    */


  _createClass(GroupPurchase, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (window.vexpo && window.vexpo.firebase) {
        window.vexpo.firebase.database().ref('affiliates/' + this.props.token).once('value', function (snapshot) {
          if (snapshot.exists()) {
            _this2.setState({ status: "loaded", affiliate: snapshot.val() });
          } else {
            _this2.setState({ status: "not found" });
          }
        });
      }
    }
    /** @method render
      * Displays a purchase button for the
      * associated group, or, if it wasn't found,
      * prompts the user to check the list of
      * affiliates
      */

  }, {
    key: 'render',
    value: function render() {
      switch (this.state.status) {
        case "loading":
          return _react2.default.createElement(
            'p',
            null,
            'loading...'
          );
        case "not found":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              null,
              'Fundraising Group Not Found'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The url you used does not appear to belong to a fundraising group. You may be able to find your group in this',
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/fundrasing' },
                ' list of show affiliates'
              )
            )
          );
        case "loaded":
          var name = this.state.affiliate.group ? this.state.affiliate.group : this.state.affiliate.organization;
          return _react2.default.createElement(
            Col,
            null,
            _react2.default.createElement(
              'h1',
              null,
              name
            ),
            _react2.default.createElement(
              Invite,
              null,
              'Invites you to support our group through the purchase of a ',
              _react2.default.createElement(
                Price,
                null,
                '$15'
              ),
              ' Fundraiser Gift & Discount package to the ',
              this.props.name,
              '.'
            ),
            _react2.default.createElement(_paypalButton2.default, {
              expoName: this.props.name,
              expoID: this.props.expoID,
              showID: this.props.showID,
              affiliateName: name,
              token: this.props.token,
              size: 'large'
            })
          );
      }
    }
  }]);

  return GroupPurchase;
}(_react.Component);

exports.default = GroupPurchase;


GroupPurchase.propTypes = {
  name: _propTypes2.default.string.isRequired,
  expoID: _propTypes2.default.string.isRequired,
  showID: _propTypes2.default.string.isRequired,
  token: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/fundraising/group-purchase.js
// module id = 717
// module chunks = 0